import apiClient from './client'
import type { ShowCampaign, ShowCampaignDailyStatsResponse, ShowCampaignRequest, ShowCampaignStats } from '../types'

export const showsApi = {
  listCampaigns: async (): Promise<ShowCampaign[]> => {
    const response = await apiClient.get('/api/v1/show-campaigns')
    return response.data.campaigns || []
  },

  getCampaign: async (id: string): Promise<ShowCampaign> => {
    const response = await apiClient.get(`/api/v1/show-campaigns/${id}`)
    return response.data
  },

  createCampaign: async (data: ShowCampaignRequest): Promise<ShowCampaign> => {
    const response = await apiClient.post('/api/v1/show-campaigns', data)
    return response.data
  },

  updateCampaign: async (id: string, data: Partial<ShowCampaignRequest>): Promise<ShowCampaign> => {
    const response = await apiClient.put(`/api/v1/show-campaigns/${id}`, data)
    return response.data
  },

  deleteCampaign: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/v1/show-campaigns/${id}`)
  },

  getStats: async (id: string): Promise<ShowCampaignStats> => {
    const response = await apiClient.get(`/api/v1/show-campaigns/${id}/statistics`)
    return response.data
  },

  getDailyStats: async (id: string, startDate?: string, endDate?: string): Promise<ShowCampaignDailyStatsResponse> => {
    const response = await apiClient.get(`/api/v1/show-campaigns/${id}/statistics/daily`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    })
    return response.data
  },
}
